/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getGlobal = require("../getGlobal");
var globalObject = (0, _getGlobal.getGlobal)();
function containsNode(parent, child) {
  if (!parent || !child || !(parent instanceof Element) || !(child instanceof Element)) {
    return false;
  }
  if (!globalObject.document.body.contains(child)) {
    return false;
  }
  var result = true;
  if (parent !== child && !parent.contains(child)) {
    result = false;
  }
  return result;
}
var _default = containsNode;
exports.default = _default;